<template>
  <div class="container-engagement-per-hour">
    <span class="container-engagement-title">Comparativo de horário de engajamento</span>
    <CustomSkeleton v-if="isSearching" type="verticalGraph" />
    <canvas v-if="!isSearching" id="engagement-per-hour-chart" class="engagement-per-hour-chart" />
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js'
import CustomSkeleton from '@/Shared/CustomSkeleton'
Chart.register(...registerables)
export default {
  props: {
    isSearching: Boolean,
  },
  components: {
    CustomSkeleton,
  },
  data() {
    return {
      isLoadingReviews: false,
      chart: null,
      touristAttractionsData: [
        { name: 'Cristo Redentor', visits: 5000 },
        { name: 'Pão de Açúcar', visits: 4500 },
        { name: 'Praia de Copacabana', visits: 6000 },
        { name: 'Parque Ibirapuera', visits: 5500 },
        { name: 'Museu do Amanhã', visits: 4000 },
        { name: 'Jardim Botânico', visits: 4800 },
      ],
    }
  },
  watch: {
    isSearching: {
      handler(n, o) {
        if (o === true) {
          setTimeout(() => {
            this.createChart()
          }, 1000)
        }
      },
      immediate: true,
    },
  },
  methods: {
    createChart() {
      if (this.chart) {
        this.chart.destroy()
      }
      const ctx = document.getElementById('engagement-per-hour-chart').getContext('2d')
      const canvas = document.getElementById('engagement-per-hour-chart')
      canvas.width = 400
      canvas.height = 400
      const labels = this.touristAttractionsData.map((attraction) => attraction.name)
      const data = this.touristAttractionsData.map((attraction) => attraction.visits)
      const backgroundColors = '#9747FF'
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              data,
              backgroundColor: backgroundColors,
              borderWidth: 1,
              barThickness: 30,
            },
          ],
        },
        options: {
          indexAxis: 'x',
          scales: {
            x: {
              beginAtZero: true,
              title: {
                display: false,
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
        },
      })
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
